import * as React from 'react';

import styled from '@emotion/styled';
import { breakpoints } from '../styles/breakpoints';

const StyledFeature = styled.div`
	padding: var(--small) var(--large);
	background: var(--white);
	box-shadow: var(--shadow-normal);
	border-radius: .7rem;

	@media(max-width: ${breakpoints.lg}) {
		padding: var(--small) var(--medium);
		max-width: 460px;
	}

	p {
		margin: var(--macro) 0 var(--small);
	}

	img {
		max-height: 19rem;
		max-width: 22rem;
		margin: auto;
		width: 100%;
	}
`;

export interface FeatureProps {
	title: string;
	text: string;
	image: string;
}

export const Feature = ({title, text, image}: FeatureProps) => (
	<StyledFeature>
		<h3 className="h3">{title}</h3>
		<p>{text}</p>
		<img src={image} alt={title} />
	</StyledFeature>
)
